<script>
    import { uniqueid } from "../scripts";
    import { createEventDispatcher } from 'svelte';

    export let title=''
    export let textButton='';
    export let classButton='btn-primary btn-sm'
    export let iconButton=false
    export let functionSi=function() {};
    export let id=uniqueid();
    export let autoopen=false;
    export let disabled=false;

    export let button=true;

    const dispatch = createEventDispatcher();

    let mymodal=null;
    let mymodal2=null;
    let bsOffcanvas=null;

    let button_close=null;

    function action()
    {
        functionSi();
        button_close.click();
    }

    $: if(mymodal!==null) {
      if(autoopen===true) {
        let bsOffcanvas = new bootstrap.Modal(mymodal2)
        bsOffcanvas.show()
      }
    }

    function mouseenter() { dispatch('mouseenter', {}); }

    function mouseleave() { dispatch('mouseleave', {}); } 

</script>
<!-- Button trigger modal -->
    <button type="button" {disabled} class:d-none={button===false} bind:this={mymodal} class="btn {classButton}" data-bs-toggle="modal" data-bs-target="#{id}" on:mouseenter={mouseenter} on:mouseleave={mouseleave}>
        {#if iconButton}<i class:me-1={textButton!=''} class="bi {iconButton}"></i>{/if}
        {textButton}
    </button>

  <!-- Modal -->
  <div class="modal fade" bind:this={mymodal2} id="{id}" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="{id}Label" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="{id}Label">{title}</h5>
          <button type="button" bind:this={button_close} class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <slot/>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">No</button>
          <button type="button" class="btn btn-success" on:click={action}>Si, lo confirmo</button>
        </div>
      </div>
    </div>
  </div>